import { Column, Editor, EditorArguments, EditorValidationResult } from 'angular-slickgrid';

export class CustomTimeEditor implements Editor {
  private input!: HTMLInputElement;
  private originalValue: string = '';
  private args: EditorArguments;

  constructor(args: EditorArguments) {
    this.args = args;
    this.init();
  }

  init(): void {
    const container = this.args.container as HTMLElement;

    this.input = document.createElement('input');
    this.input.type = 'time';
    this.input.className = 'editor-time';
    this.input.style.width = '100%';
    this.input.style.height = '100%';
    this.input.style.border = '1px solid #ccc';
    this.input.style.padding = '2px 4px';
    this.input.style.boxSizing = 'border-box';

    container.appendChild(this.input);
    this.input.focus();
  }

  destroy(): void {
    if (this.input) {
      this.input.remove();
    }
  }

  focus(): void {
    this.input?.focus();
  }

  loadValue(item: any): void {
    const column = this.args.column as Column;
    const fieldName = column.field || '';
    let value = item[fieldName] || '';

    if (value) {
      if (typeof value === 'string' && value.includes('T')) {
        value = value.split('T')[1]?.substring(0, 5) || '';
      } else if (typeof value === 'string' && value.length > 5) {
        value = value.substring(0, 5);
      }
    }

    this.originalValue = value;
    this.input.value = value;
    this.input.select();
  }

  serializeValue(): string {
    return this.input.value || '';
  }

  applyValue(item: any, state: string): void {
    const column = this.args.column as Column;
    const fieldName = column.field || '';
    item[fieldName] = state;
  }

  isValueChanged(): boolean {
    return this.input.value !== this.originalValue;
  }

  validate(): EditorValidationResult {
    const column = this.args.column as Column;
    const editorOptions = (column.editor as any) || {};
    const value = this.input.value;
    const fieldName = column.field || '';

    if (editorOptions.required && !value) {
      return {
        valid: false,
        msg: 'This field is required',
      };
    }

    if (value && !/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
      return {
        valid: false,
        msg: 'Invalid time format. Use HH:mm',
      };
    }

    if (editorOptions.validator) {
      const item = this.args.item || {};
      const updatedItem = { ...item, [fieldName]: value };
      const validationArgs = { ...this.args, item: updatedItem };
      return editorOptions.validator(value, validationArgs);
    }

    return { valid: true, msg: '' };
  }
}
